import Icon from '../components/Icon.vue'

Icon.register({
  walking: {
    width: 320,
    height: 512,
    paths: [
      {
        d: 'M208 96c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zM302.5 245.1c15.7 7.9 22 27.3 14.3 43-7.9 15.8-26.9 22.2-42.5 14.3l-23.3-11.8c-15-7.6-26.4-20.9-31.7-37l-5.5-16.5-17.2 68.7 45.5 49.7c7.2 7.8 12.3 17.4 14.9 27.7l22.2 89c4.3 17.1-6.2 34.5-23.3 38.8-17.1 4.3-34.5-6.2-38.8-23.3l-18.3-73.3c-2.6-10.3-7.7-19.8-14.9-27.7l-59.9-65.4c-14.5-15.9-20.1-38-14.9-58.8l15.2-60.7-26.8 10.8c-7.2 2.9-13 8.4-16.5 15.4l-6.7 13.6c-7.9 15.8-26.9 22.2-42.5 14.3-15.7-7.9-22-27.1-14.2-42.9l6.7-13.6c10.4-21 28.1-37.5 49.7-46.2 37.4-15.1 57.3-25.3 93.3-25.2 46.5 0.1 87.5 31.3 102.2 75.9l9.7 29.4zM73.6 385.8l20.7-51.5c8.7 11.9-7.9-6.6 47.4 53.7l-13.5 33.8c-3.3 8.1-8.1 15.4-14.2 21.5l-59.4 59.4c-12.5 12.5-32.7 12.5-45.2 0s-12.5-32.8 0-45.3l50-50.1c6.2-6.1 11-13.4 14.2-21.5z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/walking.js
// module id = 2101
// module chunks = 0